export default "__VITE_ASSET__6e5e641e__"